<template>
  <div class="update-phone">
    <Header :show="true" :isShadow="false" title="手机号码修改" />
    <div class="content">
      <div class="detail">
        <div class="formData">
          <div class="form">
            <van-field
              class="pageInput"
              v-if="type === 0"
              v-model="phone"
              label="原手机号码"
              clearable
              :border="false"
              :readonly="true"
              type="number"
              maxlength="11"
              placeholder="请输入手机号码"
            />
            <van-field
              class="pageInput"
              v-else
              v-model="newPhone"
              label="新手机号码"
              clearable
              :border="false"
              type="number"
              maxlength="11"
              placeholder="请输入新手机号码"
            />
            <van-field
              class="pageInput"
              label="短信验证码"
              v-model="code"
              maxlength="6"
              placeholder="验证码"
            >
              <template #button>
                <KBtn
                  v-if="type === 0"
                  size="small"
                  :title="codeText"
                  :disabled="disabled"
                  @click="getCode"
                  clearable
                  color="var(--depYelColor)"
                />
                <KBtn
                  v-else
                  size="small"
                  :title="codeText2"
                  :disabled="disabled2"
                  @click="getCode"
                  clearable
                  color="var(--depYelColor)"
                />
              </template>
            </van-field>
            <div v-show="remainingModifyCount != -1" class="modify-count">
              <span class="count-label">剩余修改次数：</span>
              <span class="count-value" :class="{ 'count-zero': remainingModifyCount === 0 }">{{remainingModifyCount}}</span>
            </div>
            <KBtn
              size="big"
              :title="btnTitle"
              color="var(--depYelColor)"
              @click="handleConfirm"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userRegister, getCode, checkCode, getRemainingModifyCountApi } from "api/user";

export default {
  data() {
    return {
      code: "",
      phone: null,
      newPhone: null,
      type: 1,
      disabled: false,
      disabled2: false,
      codeText: "获取验证码",
      codeText2: "获取验证码",
      btnTitle: "下一步",
      isSend: false,
      remainingModifyCount: -1,
    };
  },
  created() {
    this.phone = this.$route.query.phone;
    this.getRemainingModifyCount()
  },
  methods: {
    getRemainingModifyCount(){
      getRemainingModifyCountApi().then(({data, status, message}) => {
        if (status === 200) {
          this.remainingModifyCount = data
        } else {
          this.$error(message);
        }
      })
    },
    getCode() {
      if(this.phone == this.newPhone){
          this.$error("新手机号与原手机号无异");
          return;
      }
      if(this.remainingModifyCount == 0){
          this.$error("剩余修改次数不足");
          return;
      }
      if (this.type === 0 && this.formatPhone(this.phone) && !this.disabled) {
        this.disabled = true;
        getCode(this.phone, 2)
          .then((res) => {
            if (res.status === 200) {
              this.isSend = true;
              this.downTime();
              this.$success("短信验证码已发送");
            } else {
              this.disabled = false;
              this.$error(res.message);
            }
          })
          .catch((err) => {
            this.disabled = false;
          });
      }
      if (
        this.type === 1 &&
        this.formatPhone(this.newPhone) &&
        !this.disabled2
      ) {
        this.disabled2 = true;
        getCode(this.newPhone, 0)
          .then((res) => {
            if (res.status === 200) {
              this.isSend = true;
              this.downTime2();
              this.$success("短信验证码已发送");
            } else {
              this.disabled2 = false;
              this.$error(res.message);
            }
          })
          .catch((err) => {
            this.disabled2 = false;
          });
      }
    },
    handleConfirm() {
      let mobile = this.type === 0 ? this.phone : this.newPhone;
      if (this.formatPhone(mobile)) {
        if (!this.isSend) {
          this.$error("请点击获取短信验证码");
          return false;
        }
        if (!this.code) {
          this.$error("请输入验证码");
          return false;
        }
        if (this.code.length < 6) {
          this.$error("请输入6位的验证码");
          return false;
        }
        this.$loading("操作执行中...");
        if (this.type === 0) {
          checkCode(this.code).then((res) => {
            this.$clear();
            if (res.status === 200) {
              this.type = 1;
              this.btnTitle = "确定";
              this.clearCode();
            } else {
              this.$error(res.message);
            }
          });
        } else {
          userRegister(this.newPhone, this.code, this.type).then((res) => {
            this.$clear();
            if (res.status === 200) {
              this.$successSync("修改成功", () => {
                this.$replace({
                  path: "/coupons",
                });
              });
            } else {
              this.$error(res.message);
            }
          });
        }
      }
    },
    formatPhone(phone) {
      if (!phone) {
        this.$error("手机号码不能为空");
        return false;
      }
      if (!this.$regPhone(phone)) {
        this.$error("手机号码格式错误");
        return false;
      }
      return true;
    },
    downTime() {
      let time = 59;
      let interval = setInterval(() => {
        if (time > 0) {
          let changeTime = time--;
          if (time < 10 && time > 0) {
            changeTime = "0" + time;
          }
          this.codeText = changeTime + "秒后再获取";
        } else {
          clearInterval(interval);
          this.disabled = false;
          this.codeText = "获取验证码";
        }
      }, 1000);
    },
    downTime2() {
      let time = 59;
      let interval = setInterval(() => {
        if (time > 0) {
          let changeTime = time--;
          if (time < 10 && time > 0) {
            changeTime = "0" + time;
          }
          this.codeText2 = changeTime + "秒后再获取";
        } else {
          clearInterval(interval);
          this.disabled2 = false;
          this.codeText2 = "获取验证码";
        }
      }, 1000);
    },
    clearCode() {
      this.code = "";
      this.isSend = false;
    },
  },
};
</script>

<style scoped lang="less">
.update-phone {
  .content {
    margin-top: 20px;
    position: relative;
    .detail {
      position: absolute;
      top: 0;
      left: 10px;
      right: 10px;
      border-radius: 6px;
      background: #fff;
      box-shadow: 0 0 5px #c0c0c0;
      .warning {
        margin-top: 38px;
      }
      .formData {
        margin: 25px 15px;
        .form {
          /deep/.van-cell {
            margin-top: 18px;
            height: 50px;
            line-height: 31px;
            font-size: var(--titleFont);
            /deep/.van-field__control {
              color: var(--assistantColor);
            }
          }
          /deep/.van-field__button {
            margin-top: -5px;
          }
          /deep/.van-button {
            width: 100%;
            height: 50px;
            margin-top: 10px;
            font-weight: var(--defaultFontWeight);
            border-radius: var(--defaultRadius);
          }
          /deep/.van-button--small {
            width: 90px;
            padding: 0px 5px;
            height: 27px;
            border-radius: var(--defaultRadius);
            box-sizing: border-box;
            margin-top: -3px;
            display: inline-block;
          }
        }
      }
    }
  }
}
.modify-count {
  margin-top: 12px;
  font-size: 14px;
  color: var(--depHidColor);
  display: flex;
  align-items: center;
  .count-value {
    font-weight: var(--defaultFontWeight);
    color: var(--depYelColor);
    font-size: 16px;
  }
  .count-zero {
    color: var(--redColor);
  }
}
</style>
